module.exports = __webpack_public_path__ + "media/icons/filter_icon_blue-a3058fd3.svg";